import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export const CustomInput = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiInputBase-root": {
    height: "35px",
    borderRadius: "4px",
    // backgroundColor: "var(--input-bg-color)",
    backgroundColor: "var(--color-bg-white)",
    color: "var(--color-airline-code)",
    padding: "0 0px",
    boxSizing: "border-box",
    transition: "all 0.3s ease-in-out",
    fontFamily: "Outfit",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "var(--Boxider-bg)",
    },
    "&:hover fieldset": {
      borderColor: "var(--color-primary-light)",
    },
    "&.Mui-focused": {
    // backgroundColor: "var(--input-bg-color)",
      backgroundColor: "var(--color-bg-white)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--color-primary-light)",
    },
  },
  "& .MuiInputBase-input": {
    fontWeight: 500,
    // 👇 Remove number input spinners
    MozAppearance: "textfield", // Firefox
  },
  // Chrome, Safari, Edge
  "& input[type=number]::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "& input[type=number]::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
}));
